import React, { useEffect, useState } from 'react';

import { useCurrentAppRoute } from '../../hooks/app-route-hooks';
import { pushAppRoute } from '../../data/domain/route-manager';
import { useHistory } from 'react-router';
import {
    BLUEPRINT_ORGANIZATION_NAME,
    DECIMAL_NUMBER,
    ONLY_NUMBER,
    IP_ADDRESS,
    TCP_TYPE,
    SERIAL_TYPE,
    ALPHA_NUMBERIC,
    RESTRICT_SPEC_WITHOUT_SPACE_REGEX,
    RESTRICT_BLG_DEVICE_SPACE_REGEX,
} from '../../constants';

import { useToasts } from '../../data/DataProviders/ToastProvider';
import { useAuthHelper } from '../../components/AuthContextProvider';
import { useDispatch, useSelector } from 'react-redux';
import { useDeviceMaster } from '../../data/DataProviders/DeviceMasterProvider';
import { HeaderInfo } from '../../components/HeaderInfo/HeaderInfo';
import { useLanguageLocale } from '../../hooks/language-locale-hooks';
import { baudData, starBits, starStop, communicationType, starfishParity } from '../../constants/device-data';
import {
    Box,
    Button,
    CircularProgress,
    FormControl,
    InputLabel,
    MenuItem,
    Paper,
    Select,
    SelectChangeEvent,
    TextField,
    Typography,
} from '@mui/material';
import deviceStyles from './DeviceStyle';
import { ContentContainer } from '../../components/ContentContainer';
import { GenericToolbar } from '../../components/GenericToolbar/GenericToolbar';
import { isDataLoaded } from '../../types';
import { MasterDataKey, StarfishChildDeviceRegistration } from '../../types/device';
import { DataIndicators } from '../../components/DataIndicators';
import { StarfishDeviceSelectors } from '../../selectors/starfish-device-selectors ';
import { ConfirmationPopUp } from '../../components/ConfirmationPopUp/ConfirmationPopUp';
import { Thunks } from '../../actions';
import { NavigationPromptModal } from '../../components/NavigationPromptModal/NavigationPromptModal';
import { useStarfishDeviceDetails } from '../../data/DataProviders/StarfishGatewayDeviceDetailsProvider';
import { StarfishDeviceActions } from '../../actions/actions/starfish-device-actions';
import { isRecordFound, useSelectedOrganizationData } from '../../hooks/data-hooks';
import { sortList } from '../../lib/manage-alarms-helpers';

export const AddStarFishChildDevice: React.FC = () => {
    const gatewayDeviceDetails = useStarfishDeviceDetails();
    const deviceMasterData = useDeviceMaster();

    const classes = deviceStyles();
    const { t } = useLanguageLocale();
    const history = useHistory();
    const dispatch = useDispatch();
    const [ipDeviceIpError, setDeviceIpError] = React.useState(false);
    const { addToast } = useToasts();
    const authHelper = useAuthHelper();
    const currentAppRoute = useCurrentAppRoute();
    const [childDevice, setChildDevice] = useState<StarfishChildDeviceRegistration>();
    const [communicateType, setcommunicateType] = React.useState<string>('');
    const [childDeviceType, setChildDeviceType] = React.useState<string>('');
    const [deviceProfiles, setDeviceProfiles] = useState<any[]>([]);

    const starfishDeviceState = useSelector(StarfishDeviceSelectors.deviceRegistration);
    const [deviceTypeValue, setDeviceTypeValue] = React.useState('');
    const selectedOrganization = useSelectedOrganizationData();
    const orgId = isRecordFound(selectedOrganization) ? selectedOrganization.value.id : '';
    const starfishDeviceDetails = useStarfishDeviceDetails();
    useEffect(() => {
        if (isDataLoaded(starfishDeviceDetails)) {
            const deviceType = starfishDeviceDetails.value.deviceType;
            if (deviceType && deviceType.includes('BLG_Brightlayer_Gateway_400')) {
                deviceMasterData.getDeviceTypeMasterData(BLUEPRINT_ORGANIZATION_NAME, MasterDataKey.StarfishBLG400);
            } else {
                deviceMasterData.getDeviceTypeMasterData(BLUEPRINT_ORGANIZATION_NAME, MasterDataKey.Starfish);
            }
        }
    }, [starfishDeviceDetails]); //eslint-disable-line react-hooks/exhaustive-deps

    useEffect(() => {
        if (
            isDataLoaded(deviceMasterData.deviceTypeData) &&
            deviceMasterData.deviceTypeData.value &&
            deviceMasterData.deviceTypeData.value.length > 0 &&
            (deviceMasterData.rowKey === MasterDataKey.StarfishBLG400 || deviceMasterData.rowKey === MasterDataKey.Starfish)
        ) {
            const childDeviceInfo = deviceMasterData.deviceTypeData.value;
            deviceMasterData.getDevicesInfo(BLUEPRINT_ORGANIZATION_NAME, orgId);
            if (childDeviceInfo) {
                setDeviceProfiles(childDeviceInfo);
            }
        }
    }, [deviceMasterData]); //eslint-disable-line react-hooks/exhaustive-deps

    useEffect(() => {
        if (
            isDataLoaded(deviceMasterData.deviceInfo) &&
            deviceMasterData.deviceInfo.value &&
            deviceMasterData.deviceInfo.value.length > 0 &&
            deviceMasterData.rowKey === orgId
        ) {
            const childDeviceInfo = deviceMasterData.deviceInfo.value;
            if (childDeviceInfo) {
                const orgProfiles = JSON.parse(JSON.stringify(childDeviceInfo));
                const allDeviceProfiles = orgProfiles.concat(deviceProfiles);
                sortList(allDeviceProfiles, 'key');
                setDeviceProfiles(allDeviceProfiles);
            }
        }
    }, [deviceMasterData]); //eslint-disable-line react-hooks/exhaustive-deps

    const onChangeValues = (value: string | number, type: string): void => {
        if (childDevice) {
            const deviceNameObj: any = { ...childDevice };
            deviceNameObj[`${type}`] = value;

            setChildDevice(deviceNameObj);
        }
    };
    const onChangeDeviceName = (e: React.ChangeEvent<HTMLTextAreaElement | HTMLInputElement>): void => {
        if (RESTRICT_BLG_DEVICE_SPACE_REGEX.test(e.target.value) && childDevice) {
            onChangeValues(e.target.value, 'name');
        }
    };
    const onChangeCommType = (e: any): void => {
        setcommunicateType(e.target.value);
        if (childDevice && e.target.value !== '') {
            onChangeValues(e.target.value === '' ? '' : e.target.value, 'communicationType');
        }
    };
    const onChangeDeviceIp = (e: React.ChangeEvent<HTMLTextAreaElement | HTMLInputElement>): void => {
        if (e.target.value !== '' && IP_ADDRESS.test(e.target.value)) {
            setDeviceIpError(false);
        } else {
            setDeviceIpError(true);
        }
        onChangeValues(e.target.value, 'deviceIp');
    };
    const onChangePort = (e: React.ChangeEvent<HTMLTextAreaElement | HTMLInputElement>): void => {
        if (e.target.value === '' || (ONLY_NUMBER.test(e.target.value) && childDevice)) {
            onChangeValues(e.target.value === '' ? '' : Number(e.target.value), 'port');
        }
    };

    const onChangeSerial = (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>): void => {
        if (e.target.value === '' || ALPHA_NUMBERIC.test(e.target.value)) {
            onChangeValues(e.target.value === '' ? '' : e.target.value.toString(), 'serial');
        }
    };

    const onChangeScanRate = (e: React.ChangeEvent<HTMLTextAreaElement | HTMLInputElement>): void => {
        if (e.target.value === '' || ONLY_NUMBER.test(e.target.value)) {
            onChangeValues(e.target.value === '' ? '' : Number(e.target.value), 'scanRate');
        }
    };

    const handleDeviceType = (e: SelectChangeEvent): void => {
        deviceProfiles.find((x) =>
            x.value.profileId === e.target.value ? setChildDeviceType(x.value.displayName) : ''
        );
        setDeviceTypeValue(e.target.value);
        deviceProfiles.find((x) => x.value.displayName);
    };

    const onChangeValuesOfBaud = (e: any): void => {
        if (e.target.value === '' || (ONLY_NUMBER.test(e.target.value) && childDevice)) {
            onChangeValues(e.target.value === '' ? '' : Number(e.target.value), 'baudRate');
        }
    };
    const onChangeValuesOfData = (e: any): void => {
        if (e.target.value === '' || (ONLY_NUMBER.test(e.target.value) && childDevice)) {
            onChangeValues(e.target.value === '' ? '' : Number(e.target.value), 'dataBits');
        }
    };
    const onChangeValuesOfStop = (e: any): void => {
        if (e.target.value === '' || (DECIMAL_NUMBER.test(e.target.value) && childDevice)) {
            onChangeValues(e.target.value === '' ? '' : Number(e.target.value), 'stopBits');
        }
    };
    const onChangeValuesOfParity = (e: any): void => {
        if (e.target.value === '' || childDevice) {
            onChangeValues(e.target.value === '' ? '' : e.target.value, 'parity');
        }
    };

    const onChangeValuesOfComPort = (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>): void => {
        if (e.target.value === '' || ALPHA_NUMBERIC.test(e.target.value)) {
            onChangeValues(e.target.value === '' ? '' : e.target.value.toString(), 'comPort');
        }
    };

    const onChangeDeviceAddress = (e: React.ChangeEvent<HTMLTextAreaElement | HTMLInputElement>): void => {
        if (e.target.value === '' || ONLY_NUMBER.test(e.target.value)) {
            onChangeValues(e.target.value, 'deviceAddress');
        }
    };
    const onChangeMac = (e: React.ChangeEvent<HTMLTextAreaElement | HTMLInputElement>): void => {
        if (e.target.value === '' || RESTRICT_SPEC_WITHOUT_SPACE_REGEX.test(e.target.value)) {
            onChangeValues(e.target.value, 'mac');
        }
    };
    const navigateToDeviceProfile = (): void => {
        dispatch(StarfishDeviceActions.StarfishChildDeviceRegistrationUnmounted());
        if (currentAppRoute.type === 'AddStarFishChildDevice')
            pushAppRoute(history, {
                type: 'StarfishDeviceProfile',
                orgId: currentAppRoute.orgId,
                locationId: currentAppRoute.locationId,
                siteId: currentAppRoute.siteId,
                deviceId: currentAppRoute.deviceId,
            });
    };
    const handleClose = (): void => {
        dispatch(StarfishDeviceActions.StarfishChildDeviceRegistrationUnmounted());
        navigateToDeviceProfile();
    };
    const isDirty = (childDevice && (childDevice.name !== '' || childDevice.deviceIp !== '')) || false;

    const isDisableSerial = (): boolean => {
        if (
            childDevice &&
            childDevice.comPort !== '' &&
            childDevice.baudRate !== 0 &&
            childDevice.dataBits !== 0 &&
            childDevice.parity !== '' &&
            childDevice.stopBits !== 0
        ) {
            return !(childDevice && isDirty);
        }
        return true;
    };

    const isDisableTcp = (): boolean => {
        if (
            childDevice &&
            childDevice.deviceIp !== '' &&
            !ipDeviceIpError &&
            childDevice.deviceAddress &&
            childDevice.deviceAddress.toString() !== '' &&
            childDevice.deviceAddress > 0 &&
            childDevice.port !== 0
        ) {
            return !(childDevice && isDirty);
        }
        return true;
    };

    const isDisable = (): boolean => {
        if (
            !starfishDeviceState.starfishgatewayLoading &&
            childDevice &&
            communicateType !== '' &&
            deviceTypeValue !== '' &&
            childDevice.scanRate >= 1000 &&
            childDevice.scanRate <= 3600000 &&
            Number(childDevice.deviceAddress) > 0 &&
            Number(childDevice.deviceAddress) < 255
        )
            return communicateType.toLowerCase() === SERIAL_TYPE
                ? isDisableSerial()
                : communicateType.toLowerCase() === TCP_TYPE
                    ? isDisableTcp()
                    : true;
        return true;
    };

    useEffect(() => {
        if (isDataLoaded(gatewayDeviceDetails) && currentAppRoute.type === 'AddStarFishChildDevice') {
            const device: StarfishChildDeviceRegistration = {
                siteId: currentAppRoute.siteId,
                name: '',
                serial: '',
                deviceIp: '',
                mac: '',
                deviceProfileId: '',
                parentDeviceId: gatewayDeviceDetails.value.deviceId,
                deviceAddress: 1,
                communicationType: '',
                port: 502,
                scanRate: 1000,
                deviceType: '',
                baudRate: 1200,
                parity: 'None',
                dataBits: 5,
                stopBits: 1,
                comPort: '',
                requestedFrom: '',
            };
            setChildDevice(device);
        }
    }, [gatewayDeviceDetails]);

    const onSubmit = (): void => {
        if (childDevice) {
            const starfishChildDeviceData = {
                siteId: childDevice.siteId,
                name: childDevice.name,
                serial: childDevice.serial,
                deviceIp: childDevice.deviceIp,
                mac: childDevice.mac,
                deviceProfileId: deviceTypeValue,
                parentDeviceId: childDevice.parentDeviceId || '',
                deviceAddress: childDevice.deviceAddress,
                communicationType: childDevice.communicationType,
                port: childDevice.port,
                baudRate: childDevice.baudRate,
                parity: childDevice.parity,
                dataBits: childDevice.dataBits,
                stopBits: childDevice.stopBits,
                comPort: childDevice.comPort,
                pushRate: 1,
                scanRate: childDevice.scanRate,
                deviceType: childDeviceType,
                requestedFrom: 'Remote',
            };
            dispatch(
                Thunks.StarfishChildDevice.StarfishChildDeviceRegistration(
                    starfishChildDeviceData,
                    authHelper,
                    addToast
                )
            );
        }
    };

    //
    return (
        <>
            <GenericToolbar
                showBackButton
                backButtonOnClick={(): void => {
                    if (currentAppRoute.type === 'AddStarFishChildDevice')
                        pushAppRoute(history, {
                            type: 'StarfishDeviceProfile',
                            orgId: currentAppRoute.orgId,
                            locationId: currentAppRoute.locationId,
                            siteId: currentAppRoute.siteId,
                            deviceId: currentAppRoute.deviceId,
                        });
                }}
                title="Add Device"
            //subtitle={gatewayDeviceName}
            />
            <ContentContainer>
                <Paper style={{ padding: 56 }}>
                    {!isDataLoaded(gatewayDeviceDetails) && (
                        <DataIndicators
                            errorMessage="Gateway record not found"
                            emptyMessage="Gateway record not found"
                            inline
                            data={gatewayDeviceDetails}
                            emptyIcon="Devices"
                            isEmpty={false}
                            isDetailedInfo={false}
                        />
                    )}
                    {isDataLoaded(gatewayDeviceDetails) && childDevice && (
                        <>
                            <Box>
                                {!isDataLoaded(deviceMasterData.deviceInfo) && (
                                    <DataIndicators
                                        errorMessage="Record not found"
                                        emptyMessage="Record not found"
                                        inline
                                        data={deviceMasterData.deviceInfo}
                                        emptyIcon="Devices"
                                        isEmpty={false}
                                        isDetailedInfo={false}
                                    />
                                )}
                                {isDataLoaded(deviceMasterData.deviceInfo) && (
                                    <>
                                        <HeaderInfo title="Device Information" entity="to add a Device" />
                                        <Box className={classes.padding8}>
                                            <FormControl variant="filled" required className={`${classes.fullWidth}`}>
                                                <InputLabel id="deviceTypeData" data-testid="device-label-dd">
                                                    Supported Device Type
                                                </InputLabel>
                                                <Select
                                                    label="deviceType"
                                                    onChange={(e): void => {
                                                        handleDeviceType(e);
                                                    }}
                                                    variant="filled"
                                                    defaultValue="0"
                                                    value={deviceTypeValue}
                                                    required
                                                    inputProps={{ 'data-testid': 'device-dd' }}
                                                >
                                                    {isDataLoaded(deviceMasterData.deviceInfo) &&
                                                        deviceProfiles.map(
                                                            (
                                                                deviceData: {
                                                                    key: string;
                                                                    value: {
                                                                        profileId: string;
                                                                        displayName: string;
                                                                        disabled: boolean;
                                                                    };
                                                                },
                                                                index: number
                                                            ) => (
                                                                <MenuItem
                                                                    key={index}
                                                                    value={deviceData.value.profileId}
                                                                    data-testid={`device-type-menu${index}`}
                                                                    disabled={deviceData.value.disabled}
                                                                >
                                                                    {deviceData.value.displayName}
                                                                </MenuItem>
                                                            )
                                                        )}
                                                </Select>
                                            </FormControl>
                                        </Box>
                                        <Box className={classes.padding8}>
                                            <TextField
                                                inputProps={{ 'data-testid': 'device-name', maxLength: 24 }}
                                                fullWidth
                                                required
                                                variant="filled"
                                                id="DeviceName"
                                                label="Device Name"
                                                value={childDevice.name}
                                                onChange={(e): void => {
                                                    onChangeDeviceName(e);
                                                }}
                                            />
                                        </Box>
                                        <Box style={{ width: '100%' }} className={classes.padding8}>
                                            <TextField
                                                inputProps={{
                                                    'data-testid': 'scan-rate',
                                                    width: '50%',
                                                    maxLength: 7,
                                                }}
                                                fullWidth
                                                required
                                                variant="filled"
                                                id="scanRate"
                                                label="Scan Rate (In Milliseconds)"
                                                value={childDevice.scanRate}
                                                error={
                                                    !(childDevice.scanRate >= 1000 && childDevice.scanRate <= 3600000)
                                                }
                                                onChange={(e): void => {
                                                    onChangeScanRate(e);
                                                }}
                                                helperText={
                                                    'Valid Scan Rate is between 1000 ms - 3600000 ms'
                                                }
                                            />
                                        </Box>
                                        <Box className={classes.paddingTextbox}>
                                            <TextField
                                                inputProps={{ 'data-testid': 'device-address' }}
                                                required
                                                fullWidth
                                                id="deviceAddress"
                                                label={'Device Address'}
                                                variant="filled"
                                                error={
                                                    !(
                                                        childDevice.deviceAddress &&
                                                        Number(childDevice.deviceAddress) > 0 &&
                                                        Number(childDevice.deviceAddress) < 255
                                                    )
                                                }
                                                helperText="Valid Device address is between 1 - 255."
                                                value={childDevice.deviceAddress}
                                                onChange={(e: any): void => {
                                                    onChangeDeviceAddress(e);
                                                }}
                                            />
                                        </Box>
                                        <Box className={classes.padding8}>
                                            <TextField
                                                inputProps={{ 'data-testid': 'serial', maxLength: 255 }}
                                                className={classes.fullWidth}
                                                variant="filled"
                                                value={childDevice.serial}
                                                id="DeviceSerial"
                                                label="Serial Number"
                                                onChange={(e): void => onChangeSerial(e)}
                                            />
                                        </Box>
                                        <Box className={`${classes.padding8}`}>
                                            <FormControl variant="filled" required fullWidth>
                                                <InputLabel id="communicationType" data-testid="communicationType">
                                                    Communication Type
                                                </InputLabel>
                                                <Select
                                                    label="communicationType"
                                                    value={childDevice.communicationType}
                                                    required
                                                    inputProps={{ 'data-testid': 'communicationType-dd', width: '50%' }}
                                                    onChange={(e): void => {
                                                        onChangeCommType(e);
                                                    }}
                                                >
                                                    {communicationType.map(
                                                        (data: { key: string; value: string }, index: number) => (
                                                            <MenuItem
                                                                key={index}
                                                                value={data.value}
                                                                data-testid={`communicationType${index}`}
                                                            >
                                                                {data.value}
                                                            </MenuItem>
                                                        )
                                                    )}
                                                </Select>
                                            </FormControl>
                                        </Box>

                                        {communicateType.toLowerCase() === TCP_TYPE && (
                                            <>
                                                <Box className={classes.paddingTextbox}>
                                                    <TextField
                                                        id="mac"
                                                        style={{ width: '100%' }}
                                                        variant="filled"
                                                        label="Mac"
                                                        data-testid="mac"
                                                        value={childDevice.mac}
                                                        inputProps={{ maxLength: 255 }}
                                                        onChange={(e: any): void => {
                                                            onChangeMac(e);
                                                        }}
                                                    />
                                                </Box>
                                                <Box className={classes.padding8}>
                                                    <TextField
                                                        inputProps={{ 'data-testid': 'ip-address' }}
                                                        required
                                                        fullWidth
                                                        id="deviceIp"
                                                        label={'Device IP '}
                                                        error={ipDeviceIpError}
                                                        helperText={ipDeviceIpError ? 'Invalid Device IP' : ''}
                                                        variant="filled"
                                                        value={childDevice.deviceIp}
                                                        onChange={(e): void => {
                                                            onChangeDeviceIp(e);
                                                        }}
                                                    />
                                                </Box>
                                                <Box className={classes.padding8}>
                                                    <TextField
                                                        inputProps={{ 'data-testid': 'port', maxLength: 5 }}
                                                        fullWidth
                                                        required
                                                        variant="filled"
                                                        id="port"
                                                        label="Port"
                                                        error={
                                                            !(
                                                                childDevice.port &&
                                                                Number(childDevice.port) > 0 &&
                                                                Number(childDevice.port) < 65535
                                                            )
                                                        }
                                                        helperText="Valid Port are between 0 - 65535."
                                                        value={childDevice.port}
                                                        onChange={(e): void => {
                                                            onChangePort(e);
                                                        }}
                                                    />
                                                </Box>
                                            </>
                                        )}
                                        {communicateType.toLowerCase() === SERIAL_TYPE && (
                                            <>
                                                <Box className={classes.padding8}>
                                                    <FormControl
                                                        variant="filled"
                                                        required
                                                        className={classes.fullWidth}
                                                    >
                                                        <InputLabel id="baudRateData" data-testid="baud-rate">
                                                            Baud Rate
                                                        </InputLabel>
                                                        <Select
                                                            label="baudRate"
                                                            value={childDevice.baudRate}
                                                            required
                                                            inputProps={{ 'data-testid': 'baud-rate-dd' }}
                                                            onChange={(e): void => {
                                                                onChangeValuesOfBaud(e);
                                                            }}
                                                        >
                                                            {baudData.map(
                                                                (
                                                                    data: { key: string; value: string },
                                                                    index: number
                                                                ) => (
                                                                    <MenuItem
                                                                        key={index}
                                                                        value={data.key}
                                                                        data-testid={`baud-data${index}`}
                                                                    >
                                                                        {data.value}
                                                                    </MenuItem>
                                                                )
                                                            )}
                                                        </Select>
                                                    </FormControl>
                                                </Box>
                                                <Box
                                                    className={`${classes.padding8}`}
                                                    display="flex"
                                                    justifyContent="space-between"
                                                >
                                                    <Box
                                                        style={{ width: '50%', paddingLeft: 0 }}
                                                        className={`${classes.padding8}`}
                                                    >
                                                        <FormControl variant="filled" required fullWidth>
                                                            <InputLabel id="bits" data-testid="bits">
                                                                Data Bits
                                                            </InputLabel>
                                                            <Select
                                                                label="dataBits"
                                                                value={childDevice.dataBits}
                                                                required
                                                                inputProps={{
                                                                    'data-testid': 'dataBits-dd',
                                                                    width: '50%',
                                                                }}
                                                                onChange={(e): void => {
                                                                    onChangeValuesOfData(e);
                                                                }}
                                                            >
                                                                {starBits.map(
                                                                    (
                                                                        data: { key: number; value: string },
                                                                        index: number
                                                                    ) => (
                                                                        <MenuItem
                                                                            key={index}
                                                                            value={data.key}
                                                                            data-testid={`data-bits${index}`}
                                                                        >
                                                                            {data.value}
                                                                        </MenuItem>
                                                                    )
                                                                )}
                                                            </Select>
                                                        </FormControl>
                                                    </Box>
                                                    <Box
                                                        style={{ width: '50%', paddingRight: 0 }}
                                                        className={`${classes.padding8}`}
                                                    >
                                                        <TextField
                                                            inputProps={{ 'data-testid': 'comPort', maxLength: 10 }}
                                                            className={classes.fullWidth}
                                                            variant="filled"
                                                            required
                                                            value={childDevice.comPort}
                                                            id="comPort"
                                                            label="ComPort"
                                                            onChange={(e): void => onChangeValuesOfComPort(e)}
                                                        />
                                                    </Box>
                                                </Box>
                                                <Box
                                                    className={`${classes.padding8}`}
                                                    display="flex"
                                                    justifyContent="space-between"
                                                >
                                                    <Box
                                                        style={{ width: '50%', paddingLeft: 0 }}
                                                        className={`${classes.padding8}`}
                                                    >
                                                        <FormControl variant="filled" required fullWidth>
                                                            <InputLabel id="parityData" data-testid="parity">
                                                                Parity
                                                            </InputLabel>
                                                            <Select
                                                                label="parity"
                                                                value={childDevice.parity}
                                                                required
                                                                inputProps={{
                                                                    'data-testid': 'parity-dd',
                                                                    width: '50%',
                                                                }}
                                                                onChange={(e): void => {
                                                                    onChangeValuesOfParity(e);
                                                                }}
                                                            >
                                                                {starfishParity.map(
                                                                    (
                                                                        data: { key: string; value: string },
                                                                        index: number
                                                                    ) => (
                                                                        <MenuItem
                                                                            key={index}
                                                                            value={data.value}
                                                                            data-testid={`parity${index}`}
                                                                        >
                                                                            {data.value}
                                                                        </MenuItem>
                                                                    )
                                                                )}
                                                            </Select>
                                                        </FormControl>
                                                    </Box>

                                                    <Box
                                                        style={{ width: '50%', paddingRight: 0 }}
                                                        className={`${classes.padding8}`}
                                                    >
                                                        <FormControl variant="filled" required fullWidth>
                                                            <InputLabel id="baudRateData" data-testid="baud-rate">
                                                                Stop Bits
                                                            </InputLabel>
                                                            <Select
                                                                label="baudRate"
                                                                value={childDevice.stopBits}
                                                                required
                                                                inputProps={{
                                                                    'data-testid': 'stop-bits-dd',
                                                                    width: '50%',
                                                                }}
                                                                onChange={(e): void => {
                                                                    onChangeValuesOfStop(e);
                                                                }}
                                                            >
                                                                {starStop.map(
                                                                    (
                                                                        data: { key: number; value: string },
                                                                        index: number
                                                                    ) => (
                                                                        <MenuItem
                                                                            key={index}
                                                                            value={data.value}
                                                                            data-testid={`stop-bits${index}`}
                                                                        >
                                                                            {data.value}
                                                                        </MenuItem>
                                                                    )
                                                                )}
                                                            </Select>
                                                        </FormControl>
                                                    </Box>
                                                </Box>
                                            </>
                                        )}
                                        <Box className={classes.rightSideButtonPosition}>
                                            <Button
                                                style={{ marginRight: 16 }}
                                                variant="outlined"
                                                color="primary"
                                                data-testid="cancel-device"
                                                onClick={(): void => navigateToDeviceProfile()}
                                            >
                                                {t('ACTIONS.CANCEL')}
                                            </Button>
                                            <Button
                                                variant="contained"
                                                disabled={isDisable()}
                                                startIcon={
                                                    starfishDeviceState.starfishgatewayLoading ? (
                                                        <CircularProgress size="1rem" style={{ color: 'white' }} />
                                                    ) : (
                                                        <></>
                                                    )
                                                }
                                                color="primary"
                                                data-testid="add-device-button"
                                                onClick={onSubmit}
                                            >
                                                Submit
                                            </Button>
                                        </Box>
                                    </>
                                )}
                            </Box>
                        </>
                    )}
                    {starfishDeviceState.starfishgatewaySuccess && (
                        <ConfirmationPopUp
                            title="Submission Successful!"
                            titleColor="primary"
                            body={
                                <>
                                    <Typography variant="subtitle1" style={{ marginBottom: 20 }}>
                                        Your device is being remotely configured.
                                    </Typography>
                                    <Typography variant="subtitle1">
                                        Please allow 5 to 10 minutes for this configuration to be downloaded to your
                                        device.
                                    </Typography>
                                </>
                            }
                            okButtonText={'OK'}
                            show={starfishDeviceState.starfishgatewaySuccess}
                            handleOk={handleClose}
                            okButtonShow={true}
                            width="xs"
                        ></ConfirmationPopUp>
                    )}
                </Paper>
                {!starfishDeviceState.starfishgatewaySuccess && <NavigationPromptModal isDirty={isDirty} />}
            </ContentContainer>
        </>
    );
};
